// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1eE9Z","boxTitle":"Qualiphy_boxTitle__KOnZn","box":"Qualiphy_box__1wzYv","toggleWrap":"Qualiphy_toggleWrap__1P_m7"};